import paidPreparerData from '@/services/paid-preparer-data';
import taxFilingData from '@/services/tax-filing-data';
import adnData from '@/services/adn-data';
import custModel from '@/models/customer';

export default {
  namespaced: true,
  state() {
    return {
      customer: {
        unitCost: 0,
        billingStatusId: 3,
        totalAmtDue: 0,
        totalAmtPastDue: 0,
        pastBillings: [],
        notes: [],
      },
      customers: [],
      billingStatuses: [],
    };
  },
  mutations: {
    setBillingStatuses(state, payload) {
      state.billingStatuses = payload;
    },
    setCustomers(state, payload) {
      state.customers = payload;
    },
    setCustomer(state, payload) {
      state.customer = payload;
    },
    updateCustomerStatus(state, payload) {
      state.customer.isActive = payload;
    },
    updateCustomerBillStatus(state, payload) {
      state.customer.billingStatusId = payload.BillStatusId;
      state.customer.billingStatus = payload.BillStatus;
    },
    updateCustomerUnitCost(state, payload) {
      state.customer.unitCost = payload;
    },
    updateCustomerAdjustment(state, payload) {
      state.customer.adjustmentType = payload.adjustmentType;
      state.customer.adjustmentAmount = payload.adjustmentAmount;
      state.customer.adjustmentNote = payload.adjustmentNote;
    },
    updateCustomerNotes(state, payload) {
      state.customer.notes = payload;
    },
  },
  getters: {},
  actions: {
    async fetchCustomersList({ commit }) {
      const rest = await paidPreparerData.methods.getPaidPreparersList();
      commit('setCustomers', rest);
    },
    async refreshCustomerNotes({ commit }, id) {
      const notes = await paidPreparerData.methods.getNotesForSingleCustomer(id);
      commit('updateCustomerNotes', notes);
    },
    async fetchCustomer({ commit }, id) {
      const [rawCust, rawFilings, rawAdnData, rawBillings, rawNotes] = await Promise.all([
        paidPreparerData.methods.getPaidPreparerDetails(id),
        taxFilingData.methods.getTaxFilingDetailsForPP(id),
        adnData.methods.getAdnProfileForPP(id),
        paidPreparerData.methods.getBillingDocInfoForSingleCustomer(id),
        paidPreparerData.methods.getNotesForSingleCustomer(id),
      ]);
      custModel.updateCustDataFromRaw(rawCust);
      custModel.updateAdnDataFromRaw(rawAdnData.data);
      custModel.userId = id;
      custModel.currentBillableTR = rawFilings.CurrCycleTot;
      custModel.lifetimeBillableTR = rawFilings.TotalTR;
      custModel.totalAmtDue = (rawFilings.CurrCycleTot - rawFilings.VinCorTR)
                              * rawFilings.UnitCost;
      custModel.pastBillings = rawBillings;
      custModel.notes = rawNotes;

      custModel.cardStatus = custModel.deriveCreditCardStatus();

      custModel.totalAmtPastDue = rawFilings && rawFilings.TotalAmountPastDue
        ? rawFilings.TotalAmountPastDue : 0;
      commit('setCustomer', custModel);
      commit('setBillingStatuses', rawCust.BillingStatuses);
    },
    async updateCustomerStatus({ commit, state }) {
      const newStatus = state.customer.isActive ? 0 : 1;
      const payload = { active: newStatus };
      // eslint-disable-next-line max-len
      const resp = await paidPreparerData.methods.updateActiveStatusForPP(state.customer.userId, payload);
      commit('updateCustomerStatus', resp);
    },
    async updateCustomerUnitCost({ commit, state }, unitCost) {
      const payload = { unitCost };
      // eslint-disable-next-line max-len
      const resp = await paidPreparerData.methods.updateUnitCostForPP(state.customer.userId, payload);
      if (resp && resp.UnitCost) {
        commit('updateCustomerUnitCost', resp.UnitCost);
      }
    },
    async updateCustomerAdjustment({ commit, state }, adj) {
      // eslint-disable-next-line max-len
      const resp = await paidPreparerData.methods.updateAdjustmentForPP(state.customer.userId, adj);
      if (resp && resp.message && resp.message === 'adjustment successfully created') {
        commit('updateCustomerAdjustment', resp);
      }
    },
    async updateCustomerBillingStatus({ commit, state }, billStatusId) {
      const payload = { billStatusId };
      // eslint-disable-next-line max-len
      const resp = await paidPreparerData.methods.updateBillStatusForPP(state.customer.userId, payload);
      if (resp && resp.BillStatusId) {
        commit('updateCustomerBillStatus', resp);
      }
    },
  },
};
